import { render, staticRenderFns } from "./FormEmployee.vue?vue&type=template&id=6a495bfe&scoped=true&"
import script from "./FormEmployee.vue?vue&type=script&lang=ts&"
export * from "./FormEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a495bfe",
  null
  
)

export default component.exports